import { useRouter } from '@core'
import { useTran } from 'src/i18n/useTran'
import { useUser } from 'src/auth/user/useUser'
import { pages } from 'src/routing/pages'
import { msg } from 'src/i18n/texts/keys'
import React, { ComponentType } from 'react'
import { getAppContext } from 'src/context/AppContext'
import { NavLink } from 'src/layout/header/NavLink'
import { icon } from 'src/ui/icon/icons'
import { css } from 'src/ui/style/css'
import { CtaButton, CtaButtonLink } from 'src/app/CtaButton'
import { Iconed } from 'src/ui/icon/Iconed'
import { useTheme } from 'src/ui/style/useTheme'
import { IMFO_MESSAGES_STORAGE_KEY } from '../../business/InfoMessages/InfoMessages'
import { Infomessage } from '../../api/defs/Infomessage.type'
import { clearMessagesOnLogout } from '../../context/InfoMessageContext'

type UserPanelProps = {
    onUserAction?: () => void
}

export const UserPanel: ComponentType<UserPanelProps> = ({ onUserAction }) => {
    const t = useTran()
    const r = useRouter()
    const th = useTheme()
    const user = useUser()
    const ctx = getAppContext()
    const logout = async () => {
        await ctx.user.service.logOut()
    }

    const handleLogoutClick = async () => {
        await logout()

        clearMessagesOnLogout()

        onUserAction && onUserAction()
    }

    return user ? (
        <>
            <NavLink
                to={r.linkTo(pages.MyBoxes)}
                onClick={onUserAction}
                css={css`
                    // Turn off uppercase from parent
                    text-transform: none;
                    font-size: ${th.fontSize.xs};
                `}
            >
                <Iconed icon={icon.Person} color={false}>
                    {user.firstName}
                </Iconed>
            </NavLink>
            <CtaButton emphasize={false} onClick={handleLogoutClick}>
                {t(msg.ui.nav.items.logout)}
            </CtaButton>
        </>
    ) : (
        <CtaButtonLink to={r.linkTo(pages.Login)} onClick={onUserAction}>
            {t(msg.ui.nav.items.login)}
        </CtaButtonLink>
    )
}
